<script setup lang="ts">
import { IElement, PageElementOptions } from '@gohighlevel/ghl-proposals-common'
import BlocksRenderer from '../common/BlocksRenderer.vue'
import FloatingElementRenderer from '../common/FloatingElementRenderer.vue'
import { ref } from 'vue'

const props = defineProps<{
  page: IElement<PageElementOptions>
  sectionType: string
}>()

const pageParentRef = ref<HTMLElement>()

const getDraggableElement = (children: IElement[]) => {
  if (!children) return []
  return children.filter(element => element && element?.component?.isDraggable)
}

const getBlockElements = (children: IElement[]) => {
  if (!children) return []
  return children.filter(element => element && !element?.component?.isDraggable)
}
</script>

<template>
  <div
    class="document-block"
    style="flex: 1 1 0%; width: 100%; display: flex; flex-direction: column"
  >
    <FloatingElementRenderer
      :elements="
        getDraggableElement(
          props.page.component.options[props.sectionType]?.children
        )
      "
      :pageId="page.id"
      :page="page"
      :pageRef="pageParentRef"
      :parentRef="pageParentRef"
    />
    <template
      v-for="(element, index) in getBlockElements(
        page.component.options[props.sectionType]?.children
      )"
      :key="index"
    >
      <BlocksRenderer
        :page="page"
        :pageRef="pageParentRef"
        :parentRef="pageParentRef"
        :element="(element as IElement<any>)"
        :pageId="(page.id as string)"
        v-if="!element.component.isDraggable"
      />
    </template>
  </div>
</template>
